export default "__VITE_ASSET__Bd6A7Sh8__"